<template>
  <!-- 动态 -->
  <div v-if="total > 0" v-loading="fullscreenLoading">
    <div class="cont-dongtai">
      <template v-for="(item, index) in tableData">
        <!-- 文章 -->
        <div
          :key="index"
          class="pro-work-item clearfix"
          v-if="
            item.notifyType == 2 ||
              (item.notifyType == 5 && item.objectType == 2) ||
              (item.notifyType == 5 && item.notifyContent == '文章') ||
              (item.notifyType == 8 && item.objectType == 2) ||
              (item.notifyType == 8 && item.notifyContent == '文章') ||
              (item.notifyType == 10 && item.objectType == 2) ||
              (item.notifyType == 10 && item.notifyContent == '文章')
          "
        >
          <div class="user-avatar">
            <router-link
              target="_blank"
              :to="{ path: '/home', query: { userId: item.userInfo.userId } }"
              class="avatar-f"
            >
              <img
                :src="
                  `http://iss.21teacher.com/avatar/125/${
                    item.userInfo.userId
                  }/20.jpg`
                "
                alt
              />
            </router-link>
          </div>
          <div class="item-infoes">
            <!-- username 和 称号 -->
            <div class="user-name-title clearfix">
              <router-link
                target="_blank"
                :to="{ path: '/home', query: { userId: item.userInfo.userId } }"
                class="name"
                >{{ item.userInfo.userName }}
              </router-link>
              <!--                            <span class="title">{{item.userInfo.userRankName}}</span>-->
              <div
                class="new-tchh clearfix"
                v-if="
                  item.userInfo.userRankName != '' &&
                    item.userInfo.userRankName != null
                "
              >
                <i
                  class="icon zs"
                  v-if="item.userInfo.userRankName.split(',')[1] == '资深作者'"
                ></i>
                <i
                  class="icon yx"
                  v-if="item.userInfo.userRankName.split(',')[1] == '优秀作者'"
                ></i>
                <i
                  class="icon hy"
                  v-if="item.userInfo.userRankName.split(',')[1] == '活跃作者'"
                ></i>
                <span class="zuoz">{{
                  item.userInfo.userRankName.split(",")[1]
                }}</span>
                <span class="shu">|</span>
                <span class="liny">{{
                  item.userInfo.userRankName.split(",")[0]
                }}</span>
              </div>
            </div>
            <!-- 收藏 -->
            <div v-if="item.notifyType != 2" class="works-type">
              {{ item.notifyTypeStr }}
            </div>
            <!-- 文章简介 -->
            <router-link
              target="_blank"
              :to="{
                path: '/column/themedetail',
                query: { id: item.archive.id ,plate:item.archive.belongSection}
              }"
              class="others-article clearfix"
              :style="{
                border: item.notifyType != 2 ? '1px solid #eee' : 'none'
              }"
            >
              <div
                class="art-img"
                :style="{
                  backgroundImage: 'url(' + item.archive.thumbnail + ')'
                }"
              ></div>
              <div class="art-tit">
                <span class="zhuanzai" v-if="item.archive.isOriginal == 0"
                  >转载分享</span
                >
                <span class="chuang" v-if="item.archive.isOriginal != 0"
                  >原创</span
                >
                <span class="tit">{{ item.archive.archiveTitle }}</span>
              </div>
            </router-link>
            <!-- 赞 踩 评论 转发 -->
            <talkPart
              :objType="2"
              :objId="item.archive.id"
              :nid="item.id"
              :notifyType="item.notifyType"
              :key="tableData[index].id"
              :loadShow="false"
              v-if="currentUserId!= 0"
            ></talkPart>
          </div>
        </div>
        <!--作品-->
        <div
          :key="index"
          class="pro-work-item clearfix"
          v-if="
            item.notifyType == 1 ||
              (item.notifyType == 5 && item.objectType == 1) ||
              (item.notifyType == 5 && item.notifyContent == '作品') ||
              (item.notifyType == 8 && item.objectType == 1) ||
              (item.notifyType == 8 && item.notifyContent == '作品') ||
              (item.notifyType == 10 && item.objectType == 1) ||
              (item.notifyType == 10 && item.notifyContent == '作品')
          "
        >
          <div class="user-avatar">
            <router-link
              :to="{ path: '/home', query: { userId: item.userInfo.userId } }"
              class="avatar-f"
            >
              <img
                :src="
                  `http://iss.21teacher.com/avatar/125/${
                    item.userInfo.userId
                  }/20.jpg`
                "
                alt
              />
            </router-link>
          </div>
          <div class="item-infoes">
            <!-- username 和 称号 -->
            <div
              class="user-name-title clearfix"
              v-if="item.production.productionType == -1"
            >
              <router-link
                :to="{
                  path: '/home',
                  query: { userId: item.production.creatorId }
                }"
                target="_blank"
                class="name"
                >{{ item.production.creatorName }}</router-link
              >
              <!--<span class="title">{{opusData[index].rankName}}</span>-->
              <span class="gg-tit" v-if="item.production.productionType == -1"
                >广告</span
              >
              <div
                class="new-tchh clearfix"
                v-if="
                  item.userInfo.rankName != '' && item.userInfo.rankName != null
                "
              >
                <i
                  class="icon zs"
                  v-if="item.userInfo.rankName.split(',')[1] == '资深作者'"
                ></i>
                <i
                  class="icon yx"
                  v-if="item.userInfo.rankName.split(',')[1] == '优秀作者'"
                ></i>
                <i
                  class="icon hy"
                  v-if="item.userInfo.rankName.split(',')[1] == '活跃作者'"
                ></i>
                <span class="zuoz">{{
                  item.userInfo.rankName.split(",")[1]
                }}</span>
                <span class="shu">|</span>
                <span class="liny">{{
                  item.userInfo.rankName.split(",")[0]
                }}</span>
              </div>
            </div>
            <div class="user-name-title clearfix" v-else>
              <router-link
                :to="{ path: '/home', query: { userId: item.userInfo.userId } }"
                class="name"
              >
                {{ item.userInfo.userName }}
              </router-link>
              <!--                            <span class="title">{{item.userInfo.userRankName}}</span>-->
              <div
                class="new-tchh clearfix"
                v-if="
                  item.userInfo.userRankName != '' &&
                    item.userInfo.userRankName != null
                "
              >
                <i
                  class="icon zs"
                  v-if="item.userInfo.userRankName.split(',')[1] == '资深作者'"
                ></i>
                <i
                  class="icon yx"
                  v-if="item.userInfo.userRankName.split(',')[1] == '优秀作者'"
                ></i>
                <i
                  class="icon hy"
                  v-if="item.userInfo.userRankName.split(',')[1] == '活跃作者'"
                ></i>
                <span class="zuoz">{{
                  item.userInfo.userRankName.split(",")[1]
                }}</span>
                <span class="shu">|</span>
                <span class="liny">{{
                  item.userInfo.userRankName.split(",")[0]
                }}</span>
              </div>
            </div>
            <!-- 评论并分享图片效果 -->
            <div v-if="item.notifyType != 1" class="works-type">
              {{ item.notifyTypeStr }}
            </div>
            <!-- 作品简介 -->
            <div :class="{ 'others-article clearfix': item.notifyType != 1 }">
              <div
                class="aite-words"
                v-if="item.production.productionType != -1"
              >
                <router-link
                  v-if="item.notifyType != 1"
                  :to="{
                    path: '/worksdetail',
                    query: { id: item.production.id ,plate:item.production.belongSection}
                  }"
                  target="_blank"
                  class="aite"
                >
                  @{{ item.production.creatorName }}：
                </router-link>
                <router-link
                  target="_blank"
                  :to="{
                    path: '/worksdetail',
                    query: { id: item.production.id,plate:item.production.belongSection }
                  }"
                >
                  <div
                    class="morewords"
                    v-html="item.production.productionInrto"
                  ></div>
                </router-link>
              </div>
              <a
                :href="item.production.link"
                target="_blank"
                class="zhuti-img guang dongtai"
                v-if="item.production.productionType == -1"
              >
                <img :src="item.production.productionCover" alt="" />
              </a>
              <!-- 九宫格图片 -->
              <!--                            <ul class="images-list clearfix mobile-show" v-if="item.production.productionForm==1 && item.production.productionType !=-1">-->
              <!--                                <router-link v-for="(attachment, aindex) in item.production.picList"-->
              <!--                                             :to="{path:'/worksdetail',query:{id:item.production.id}}"-->
              <!--                                             target="_blank"-->
              <!--                                             class="img-grid"-->
              <!--                                             :key="aindex"-->
              <!--                                             :style="{'background-image': 'url(' + attachment.uri  + ')'}"-->
              <!--                                ></router-link>-->
              <!--                            </ul>-->
              <vue-viewer
                class="images-list clearfix"
                v-if="
                  item.production.productionForm == 1 &&
                    item.production.productionType != -1
                "
                :thumb="
                  item.production.picList.map(item => {
                    return item.uri;
                  })
                "
                :full="
                  item.production.picList.map(item => {
                    return item.uri;
                  })
                "
              >
              </vue-viewer>
              <div
                v-else-if="
                  item.production.videoSource == 1 &&
                    item.production.productionForm == 2
                "
              >
                <div
                  class="demand-play"
                  v-if="item.production.productionVideo != ''"
                >
                  <!--<cc-video :ccsrc="item.productionVideo" :ccPic="item.productionCover" v-if="item.videos.status == 1 "></cc-video>-->
                  <!--<cc-video class="common-list-video" v-if="item.videos.status == 1 " :ccPic="item.productionCover" :ccsrc="item.productionVideo"></cc-video>-->

                  <div
                    v-html="item.production.videoIframeHtml"
                    class="common-list-video"
                    v-if="item.production.videos.status == 1"
                  ></div>

                  <div
                    class="no-success-add common-list-video"
                    v-if="
                      item.production.videos.status == 0 ||
                        item.production.videos.status == 2
                    "
                  >
                    <img
                      class="img-fm"
                      :src="item.production.productionCover"
                      alt=""
                    />
                    <i
                      class="no-play-icon"
                      @click="notStatus(item.production.videos.status)"
                    ></i>
                  </div>
                </div>
              </div>

              <div
                v-else-if="
                  item.production.productionForm == 2 &&
                    item.production.videoSource == 2
                "
                v-html="item.production.videoCode"
                class="iframe-h common-list-video"
              ></div>
              <!--                            <router-link v-if="item.production.productionForm==2 && item.production.productionType !=-1"-->
              <!--                                         :to="{path:'/worksdetail',query:{id:item.production.id}}"-->
              <!--                                         class="o-video" target="_blank">-->
              <!--                                <img :src="item.production.productionCover" alt/>-->
              <!--                                <div class="mask">-->
              <!--                                    <i class="el-icon-video-play"></i>-->
              <!--                                </div>-->
              <!--                            </router-link>-->
              <div
                class="type-tags"
                v-if="item.production.productionType != -1"
              >
                <span class="tag-item">
                  <!--<router-link
                    :to="{
                      path: '/works',
                      query: {
                        parameTagId: item.production.productionType,
                        parameTagName: item.production.tagStr
                      }
                    }"
                    target="_blank"
                  >-->
                    {{ item.production.tagStr }}
                  <!--</router-link>-->
                </span>
                <span
                  v-for="(tag, tindex) in item.production.tags"
                  :key="tindex"
                  class="tag-item"
                >
                  <!--<router-link
                    :to="{
                      path: '/works',
                      query: {
                        parameTagId: item.production.productionType,
                        parameTagName: item.production.tagStr,
                        parameTagStr: tag.tag
                      }
                    }"
                    target="_blank"
                  >-->
                    {{ tag.tag }}
                  <!--</router-link>-->
                </span>
              </div>
            </div>
            <!-- 赞 踩 评论 转发 -->
            <talkPart
              :objType="1"
              :objId="item.production.id"
              :nid="item.id"
              :notifyType="item.notifyType"
              :key="tableData[index].id"
              :loadShow="false"
              v-if="currentUserId!= 0"
            ></talkPart>
          </div>
        </div>
        <!--活动-->
        <div
          :key="index"
          class="pro-work-item clearfix"
          v-if="
            item.notifyType == 3 ||
              (item.notifyType == 8 && item.objectType == 3)
          "
        >
          <div class="user-avatar">
            <router-link
              :to="{ path: '/home', query: { userId: item.userInfo.userId } }"
              class="avatar-f"
            >
              <img
                :src="
                  `http://iss.21teacher.com/avatar/125/${
                    item.userInfo.userId
                  }/20.jpg`
                "
                alt
              />
            </router-link>
          </div>
          <div class="item-infoes">
            <!-- username 和 称号 -->
            <div class="user-name-title clearfix">
              <router-link
                target="_blank"
                :to="{ path: '/home', query: { userId: item.userInfo.userId } }"
                class="name"
                >{{ item.userInfo.userName }}
              </router-link>
              <!--                            <span class="title">{{item.userInfo.userRankName}}</span>-->
              <div
                class="new-tchh clearfix"
                v-if="
                  item.userInfo.userRankName != '' &&
                    item.userInfo.userRankName != null
                "
              >
                <i
                  class="icon zs"
                  v-if="item.userInfo.userRankName.split(',')[1] == '资深作者'"
                ></i>
                <i
                  class="icon yx"
                  v-if="item.userInfo.userRankName.split(',')[1] == '优秀作者'"
                ></i>
                <i
                  class="icon hy"
                  v-if="item.userInfo.userRankName.split(',')[1] == '活跃作者'"
                ></i>
                <span class="zuoz">{{
                  item.userInfo.userRankName.split(",")[1]
                }}</span>
                <span class="shu">|</span>
                <span class="liny">{{
                  item.userInfo.userRankName.split(",")[0]
                }}</span>
              </div>
            </div>
            <!-- 收藏 分享 -->
            <div class="works-type">{{ item.notifyTypeStr }}</div>
            <!-- 主题标题 -->
            <div class="zhuti-tit">

              <router-link
                v-if="item.activity.activityType==3"
                :to="'/pro/detail?id=' + item.activity.id + '&plate='+item.activity.belongSection+''"
                target="_blank"
                >{{ item.activity.activityName }}
              </router-link>
              <router-link
                      v-if="item.activity.activityType!=3"
                      :to="'/activities/matchs/detail?id=' + item.activity.id + '&plate='+item.activity.belongSection+''"
                      target="_blank"
              >{{ item.activity.activityName }}
              </router-link>
            </div>
            <!-- 文字 -->
            <div class="user-words">时间：{{ item.activity.showTime }}</div>
            <!-- 图片 -->
            <router-link
                    v-if="item.activity.activityType==3"
                    :to="'/pro/detail?id=' + item.activity.id + '&plate='+item.activity.belongSection+''"
              target="_blank"
              class="zhuti-img"
            >
              <img :src="item.activity.activityImage" alt />
            </router-link>
            <router-link
                    v-if="item.activity.activityType!=3"
                    :to="'/activities/matchs/detail?id=' + item.activity.id + '&plate='+item.activity.belongSection+''"
                    target="_blank"
                    class="zhuti-img"
            >
              <img :src="item.activity.activityImage" alt />
            </router-link>
            <!-- 赞 转发 -->
            <talkPart
              :objType="3"
              :objId="item.activity.id"
              :nid="item.id"
              :notifyType="item.notifyType"
              :key="tableData[index].id"
              :loadShow="false"
              v-if="currentUserId!= 0"
            ></talkPart>
            <!-- 赞 转发 -->
          </div>
        </div>
      </template>
    </div>
    <div class="pagintion-f">
      <el-pagination
        background
        @current-change="getDynamicList"
        layout="prev, pager, next,jumper"
        :current-page="pageIndex"
        :page-size="pageSize"
        :total="total"
        :hide-on-single-page="true"
      ></el-pagination>
    </div>
  </div>
  <div v-else class="common-no-data">
    <img class="img" :src="require('@/assets/images/empty_img.png')" alt />
    <span class="words">抱歉！您访问的页面暂无数据</span>
  </div>
</template>

<script type="text/ecmascript-6">
import vueViewer from '@@/pub/viewer/viewer';
import talkPart from '@@/pub/talkpartdynamic/talkpartdynamic';
import axios from "axios";
import vue from "vue";

import { mapState } from "vuex";
import updateTdk from "@/utils/tdk";

vue.prototype.$axios = axios;
export default {
    components: {
        talkPart,
        vueViewer
    },
    data() {
        return {
            headTitle: "title---rrdh",
            headKeywords: "keywords---rrdh",
            headDesc: "description---rrdh",
            isMounted: false, //for control not ssr render

            tableData: [],
            total: 0,
            fullscreenLoading: true,
            userId: 0,
            currentUserId: 0,
            pageIndex: 1,
            pageSize: 10
            // callbackurl: "",
        };
    },
    computed: {
        ...mapState(["userDetail"])
    },
    tdk() {
        return {
            title: this.headTitle,
            description: this.headDesc,
            keywords: this.headKeywords,
            ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
        };
    },
    serverPrefetch() {
      return this.fetchData();
    },
    destroyed() {
        this.$store.commit("SET_USER_DETAIL", { detail: null });
    },
    mounted() {

      this.isMounted = true;
      let _this = this;
      let id = _this.$route.query.userId;

      //console.log("mounted============dt====",this.$route.query.userId)
      if (id && parseInt(id) !== 0) {
          _this.userId = id;
      }

      //console.log("mounted============dongtai===_this.global=",_this.global)

      if (_this.global.userModel != null) {
          _this.currentUserId = _this.global.userModel.id;
      }

      const alreadyIncremented = !!this.productionDetail;
      if (!alreadyIncremented) {
          this.fetchData().then(this.initData());
      } else {
          this.initData();
      }

        // let _this = this;
        // let id = _this.$route.query.userId;
        // if (id && parseInt(id) !== 0) {
        //     _this.userId = id;
        // }
        // if (_this.global.userModel != null) {
        //     _this.currentUserId = _this.global.userModel.id;
        // }
        // console.log("动态userId=" + _this.userId)
        // console.log("动态currentUserId=" + _this.currentUserId)
        // this.callbackurl = "login?callback=" + window.location.href;


        // this.getDynamicList(1);
    },
    methods: {
        fetchData(){
            return this.$store
                .dispatch("FETCH_USER_DETAIL", {
                    id: this.$route.query.userId
                })
                .finally(() => {
                    this.$loading(false);
                    this.setSeo()
                    updateTdk.call(this);
                });
        },
        initData(){
            this.getDynamicList(1);
        },
        //转码没成功提示
        notStatus(statusCode){
            if(statusCode ==2){
                this.$message.error("视频转码失败...请等待管理员处理")
            }else{
                this.$message.error("视频转码中...请耐心等待")
            }
        },

        setSeo(){
            this.headTitle = this.userDetail.userName+"的动态——人人动画网【官网】";
            this.headKeywords = this.userDetail.impressStr;
            this.headDesc =this.userDetail.userName+"的动态";
        },
        // setTitle(userId){
        //     let _this = this
        //     let head = document.getElementsByTagName('head');
        //     let meta = document.createElement('meta');
        //     let userUrl = "/rrbi/userInfo/userInfo/" + userId;
        //     _this.$axios.get(userUrl).then(function(result){
        //         if (result.data.code) {
        //             document.title =result.data.response.userName+"的动态——人人动画网【官网】"
        //             document.querySelector('meta[name="description"]').setAttribute('content', result.data.response.userName+"的动态")
        //         }
        //     })
        // },

        getDynamicList(page) {
            let _this = this;
            _this.toTop();
            _this.pageIndex = page;
            _this.fullscreenLoading = true;

            let url =
                "/rrbi/notifications/getDynamic?userId=" +
                _this.userId +
                "&pageIndex=" +
                page +
                "&pageSize=" +
                _this.pageSize +
                "&ti=" +
                new Date().getMilliseconds();
            _this.$axios.get(url).then(function (result) {
                _this.tableData = result.data.response.list;
                _this.total = result.data.response.total;
                _this.fullscreenLoading = false;

            });
        },
    }
};
</script>

<style scoped lang="less">
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}

//@import "../../../assets/less/stylePublic.less";
</style>
